import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const ResetOrderCanceled: Handler = props => {
    props.dispatch({
        type: "Pages/OrderDetails/ResetOrderCanceled",
    });
};

export const chain = [ResetOrderCanceled];

const resetOrderCanceled = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetOrderCanceled");
export default resetOrderCanceled;
